import React from "react";
import { Form, Modal } from "antd";
import AccountInfoSection from "./components/AccountInfoSection";
import TransactionDetailsSection from "./components/TransactionDetailsSection";
import useAccountTransactionModal from "./hooks/useAccountTransactionModal";
import TransferSummarySection from "./components/TransferSummarySection";

export default function AccountTransactionModal(props) {
  const [form] = Form.useForm();

  const { open, mode, onCancel, loading, selectedAccount, title, loadDashboard, loadData } = props;
  const modal = useAccountTransactionModal({
    ...props,
    form,
  });

  const handleOk = async () => {
    try {
      await modal.handleOk(); // submit/save transaction first

      await loadDashboard?.();
      await loadData?.();

      onCancel?.(); // optional: close modal after success
    } catch (error) {
      console.error(error);
    }
  };

  const isManual = mode === "MANUAL";

  return (
    <Modal
      open={open}
      title={
        <div className="flex items-center justify-between">
          <div>
            <div className="text-lg font-semibold text-slate-800">
              {`${title}`}
            </div>
          </div>
        </div>
      }
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      destroyOnHidden
      okText={isManual ? "Гүйлгээ үүсгэх" : "Шилжүүлгийг батлах"}
      cancelText="Болих"
      width={980}
      okButtonProps={{
        disabled:
          modal.isAmountExceedingWallet ||
          !modal.description ||
          modal.description.trim().length === 0,
      }}
    >
      <Form form={form} layout="vertical">
        <AccountInfoSection
          form={form}
          title={title}
          isManual={modal.isManual}
          isTransfer={modal.isTransfer}
          selectedAccount={selectedAccount}
          manualSenderInstitutionId={props.manualSenderInstitutionId}
          senderOptions={modal.senderOptions}
          transferScope={modal.transferScope}
          externalInstitutionsLoading={props.externalInstitutionsLoading}
          externalInstitutionOptions={modal.externalInstitutionOptions}
          receiverCurrencyOptions={modal.receiverCurrencyOptions}
          filteredReceiverOptions={modal.filteredReceiverOptions}
          handleTransferScopeSelect={modal.handleTransferScopeSelect}
          handleReceiverAccountSelect={modal.handleReceiverAccountSelect}
        />

        <TransactionDetailsSection
          form={form}
          isManual={modal.isManual}
          isTransfer={modal.isTransfer}
          selectedAccount={selectedAccount}
          receiverAccount={modal.receiverAccount}
          rateMode={modal.rateMode}
          senderCurrency={modal.senderCurrency}
          receiverCurrency={modal.receiverCurrency}
          isAmountExceedingWallet={modal.isAmountExceedingWallet}
          senderWalletBalance={modal.senderWalletBalance}
        />

        <TransferSummarySection
          isTransfer={modal.isTransfer}
          amount={modal.amount}
          senderRate={modal.senderRate}
          receiverRate={modal.receiverRate}
          fee={modal.fee}
          description={modal.description}
          senderCurrency={modal.senderCurrency}
          receiverCurrency={modal.receiverCurrency}
          transactionDate={modal.transactionDate}
        />
      </Form>
    </Modal>
  );
}